import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-cream px-4 py-16 md:py-24" data-id="element-56" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-57" data-mp="1nwmdnvojjcum">
        <div className="mb-10 text-center md:mb-12" data-id="element-58" data-mp="2blf2z9anqmg9">
          <p className="mb-3 text-[11px] font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-59" data-mp="2bmq8bdjr429h">GOOD TO KNOW</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-60" data-mp="21ukdzx6118r4">Frequently Asked Questions</h2>
        </div>
        <div className="space-y-3" data-id="element-61" data-mp="26t466fb7rgrx">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-blue/[0.08] bg-brand-alt" data-id="element-62" data-mp="2zazz6tvtng7h" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex min-h-[56px] w-full items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-bold text-brand-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange md:px-6 md:py-5" data-id="element-63" data-mp="1vqasydwl9d0f">
                  <span data-id="element-64" data-mp="2advwg8xdle8v">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-65" data-mp="2oeyhcicmwii7" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-66" data-mp="2jgnamghmyo47" />}
                </button>
                <AnimatePresence initial={false} data-id="element-67" data-mp="u28q68dnhnei">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.24
              }} data-id="element-68" data-mp="p35jyklxpb4y">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-brand-gray md:px-6 md:pb-6" data-id="element-69" data-mp="333lkt4feide2">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}